import type {
  FeatureFlagListener,
  FeatureFlagsService,
  FeatureFlag,
} from './FeatureFlagsService';

export abstract class BaseFeatureFlagsService implements FeatureFlagsService {
  listeners: Map<FeatureFlag, ReadonlyArray<FeatureFlagListener>> = new Map();

  abstract get(name: FeatureFlag): boolean;

  set(name: FeatureFlag, value: boolean) {
    const listeners = this.listeners.get(name) ?? [];
    listeners.forEach(listener => {
      listener(value);
    });
  }

  setUserProperties() {}

  addListener(name: FeatureFlag, listener: FeatureFlagListener) {
    this.listeners.set(name, [...(this.listeners.get(name) ?? []), listener]);
  }

  removeListener(name: FeatureFlag, listener: FeatureFlagListener) {
    this.listeners.set(
      name,
      (this.listeners.get(name) ?? []).filter(it => it !== listener),
    );
  }
}
